//
import { Model as BaseModel } from 'vue-api-query'
import qs from 'qs'

//
export default class Model extends BaseModel {
  //
  static appends = []
  static errors = {}
  static fetches = {}
  static filters = []
  static forms = {}
  static headers = []
  static includes = []

  /**
   * define a base url for a REST API
   */
  baseURL() {
      return process.env.VUE_APP_API_ROUTE
  }

  /**
   *
   */
  clean(props = []) {
      //
      var clone = this.clone()

      //
      Object.keys(clone).forEach(key => {
          if (!props.some(prop => prop === key)) {
              delete clone[key]
          }
      })

      //
      return clone
  }

  /**
   *
   */
  clone() {
      return Object.assign(Object.create(Object.getPrototypeOf(this)), this)
  }

  /**
   *
   */
  error(error) {
      return {
          response: {
              data: {
                  error,
              },
          },
      }
  }

  /**
   * 
   * @param {*} path 
   * @param {*} params 
   * @param {*} type 
   */
  excel(path = 'excel', params = {}, type = 'blob') {
    return this.request({
      method: 'GET',
      params: params,
      paramsSerializer: function (params) {
          return qs.stringify(params, {arrayFormat: 'brackets'})
      },
      responseType: type,
      url: path.length > 0 ? this.fullURL().concat('/').concat(path) : this.fullURL(),
    })
  }

  /**
   *
   */
  _excel(path = 'excel') {
      return this.request({
          responseType: 'blob',
          method: 'GET',
          url: this.fullURL()
              .concat(path),
      })
  }

  /**
   * 
   * @param {*} fetchKey 
   */
  static from(payload) {
    return new this(payload)
  }


  fetch(fetchKey) {
      return this.constructor.fetches[fetchKey+'_id'].modeler().find(this[fetchKey+'_id'])
  }

  /**
   *
   */
  static async fetchDataTable(limit, page, sort, params = {}) {
      //
      try {
          //
          return await this
              .modeler()
              .limit(limit)
              .page(page)
              .orderBy(sort)
              .params(params)
              .get()
      } catch (error) {
          //
          //console.error( error )

          //
          return []
      }
  }

  /**
   * get the full url for the current model
   */
  fullURL() {
      return [this.baseURL(), this.resource(), this.id].join('/')
  }

  /**
   * @description
   * Gets the property.
   *
   * @param      {<type>}  path    The path
   * @return     {<type>}  The property.
   */
  getProperty(path, prevent) {
      return path.split('.').reduce(this.reduceHasProperty, this) || prevent
  }

  getPropertyFrom(path, prevent, parent) {
      return path.split('.').reduce(this.reduceHasProperty, parent) || prevent
  }

  /**
   * @description
   * { function_description }
   *
   * @param      {string}  [path='pdf']  The path
   * @return     {<type>}  { description_of_the_return_value }
   */
  pdf(path = 'pdf', data = {}, type ='blob') {
    return this.request({
      responseType: type,
      method: 'GET',
      url: this.fullURL().concat('/').concat(path),
      params: data,
      validateStatus: false,
    })
  }

  /**
   *
   */
  static modeler() {
    return this
      .append(this.appends)
      .include(this.includes)
  }

  /**
   * Reduces the has property.
   *
   * @param      {<type>}  parent    The parent
   * @param      {<type>}  property  The property
   * @param      {<type>}  index     The index
   * @return     {<type>}  { description_of_the_return_value }
   */
  reduceHasProperty(parent, property) {
      return typeof parent === "object" && parent !== null ? parent[property] : undefined
  }

  /**
   * { function_description }
   *
   * @param      {<type>}  data    The data
   * @return     {<type>}  { description_of_the_return_value }
   */
  replace(data) {
      return this.$http.request({
          method: 'patch',
          url: this._fromResource,
          data,
      })
  }

  /**
   * implement a default request method
   *
   * @param {*} config
   */
  request(config) {
      return this.$http.request(config)
  }

  /**
   *
   */
  reset() {
      return this
  }

  /**
   * 
   */
  static setIncludes(includes = []) {
    this.includes = Array.from(includes); return this;
  }

  /**
   * 
   */
  static setAppends(appends = []) {
    this.appends = Array.from(appends); return this;
  }

  /**
   *
   */
  showFile = (filename, fileExtend) => res => {
      //
      var fileLink = document.createElement('a')
      var fileURL = URL.createObjectURL(res.data)
      //
      fileLink.href = fileURL
      fileLink.download = filename.concat('.').concat(fileExtend)
      //file
      //console.log(fileURL)
      //fileURL.setAttribute('download', filename)

      //window.open(fileURL)
      fileLink.click()
  }

  /**
   * Returns a create representation of the object.
   *
   * @return     {<type>}  Create representation of the object.
   */
  toCreate() {
      return this.clean()
  }

  /**
   * Returns a service representation of the object.
   *
   * @return     {<type>}  Service representation of the object.
   */
  static toService() {
      return this.append(this.appends).include(this.includes)
  }

  /**
   * Returns an update representation of the object.
   *
   * @return     {<type>}  Update representation of the object.
   */
  toUpdate() {
      return this.clean(['id'])
  }

  /**
   * 
   * @param {*} path 
   * @param {*} params 
   * @param {*} type 
   */
  txt(path = 'txt', params = {}, type = 'blob') {
    return this.request({
      method: 'GET',
      params: params,
      paramsSerializer: function (params) {
          return qs.stringify(params, {arrayFormat: 'brackets'})
      },
      responseType: type,
      url: path.length > 0 ? this.fullURL().concat('/').concat(path) : this.fullURL(),
    })
  }
}
